<template src="@/templates/serviceDelivery/sdUploaded.html"></template>

<script>
import ServiceDeliveryFormCollection from "@/collections/serviceDeliveryFormCollection";
import fileView from "@/components/file/FileView";
import BookingListItem from "@/components/bookings/BookingListItem";
import { mapActions } from "vuex";

export default {
  name: "SDUploaded",
  props: ["booking_view"],
  components: {
    fileView,
    BookingListItem,
  },
  data() {
    return {
      serviceDeliveryFormCollection: new ServiceDeliveryFormCollection(),
      viewSDUploadedDetailsComp: false,
      current_ref_num: 0,
    };
  },
  created() {
    this.fetchUploadedSlips();
  },
  methods: {
    ...mapActions(["updateHideAll", "updateBackButton"]),
    fetchUploadedSlips() {
      this.updateHideAll();
      this.updateBackButton(false);

      this.serviceDeliveryFormCollection
        .getSDFUList()
        .then((SDFCollectionRes) => {
          this.serviceDeliveryFormCollection.models =
            SDFCollectionRes.response.data;
        })
        .catch((PCError) => {
          console.error("error status code");
          console.log(PCError.response.response.status);
          if (PCError.response) {
            if (PCError.response.response.status == "401") {
              Event.$emit("tokenExpiredLogout");
              return;
            }
          }

          let errorMessage = "Network error. " + PCError;
          this.fetchError(errorMessage);
          console.error(PCError);
        });
    },
    fetchError(errorMessage) {
      this.$vs.notify({
        title: "Error!",
        text: errorMessage,
        time: 4000,
        color: "danger",
        position: "top-center",
      });
    },
    moreDeliveryDetails(model) {
      return (
        "Ref: " +
        model.ref_num +
        "\n" +
        "Language: " +
        model.language +
        "\n" +
        "Service Date: " +
        model.service_date_formatted +
        "\n" +
        "Duration: " +
        model.start +
        " to " +
        model.end
      );
    },
  },
};
</script>
